import React from 'react';
import PropTypes from 'prop-types';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { Button } from '@smartplatform/ui';
import store from '../../store';

@observer
export default class Routes extends React.Component {

	@observable pages = [];
	@observable isLoading = true;
	@observable done = false;
	
	constructor(props) {
		super(props);
		this.init();
	}
	
	init = async () => {
		const pages = await store.model.Page.find({
			where: {
				route: { regexp: '^[\\w\\d]+' }
			},
			fields: ['id', 'route', 'parentId'],
			order: 'route asc',
		});
		for (let page of pages) {
			page._correctRoute = observable.box('');
		}
		this.pages = pages;
		for (let page of this.pages) {
			const full = await this.getFullRoute(page);
			page._correctRoute.set(full);
		}
		this.isLoading = false;
	};
	
	getFullRoute = async page => {
		const routes = [];
		const getParent = async page => {
			if (page.parentId) {
				const parent = await store.model.Page.findById(page.parentId, { fields: ['id', 'route', 'parentId']});
				const isFull = /^\/.+/.test(parent.route);
				const route = isFull ? parent.route.split('/').splice(-1) : parent.route;
				routes.splice(0, 0, route);
				await getParent(parent);
			}
		};
		await getParent(page);
		routes.push(page.route);
		return '/' + routes.join('/');
	};
	
	convert = async () => {
		for (let page of this.pages) {
			page.route = page._correctRoute.get();
			await page.save();
		}
		this.done = true;
	};
	
	render() {
		return <div>
			<div>
				<Button onClick={this.convert} className="btn-primary" disabled={this.isLoading || this.done}>Конвертировать роуты</Button>
				{this.isLoading ? ' Загрузка...' : ''}
			</div>
			<br />
			{this.pages.length > 0 ?
				<table className="bad-routes">
					<tbody>
					{this.pages.map(page => <tr key={page.id}>
						<td>{page.route}</td>
						<td>{page._correctRoute.get()}</td>
					</tr>)}
					</tbody>
				</table>
				:
				<div>Страниц с некорректными роутами не найдено</div>
			}
		</div>;
	}
	
}
